<template>
     <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="800px"
              scrollable
    >
        <v-card v-if="dialog">
            <GmapMap
                :center="{lat: 52.5072, lng: -1.1276}"
                :zoom="7"
                style="width: 100%; height: 650px"
                :options="mapOptions"
                @click="addMarker"
            >
            <GmapMarker v-if="marker"
                :position="marker"
                :clickable="true"
                :draggable="true"
                @dragend="dragMarker"
                :icon="markerIcon"
                />
            </GmapMap>
            <!-- <div style="position: absolute; bottom: 15px; left: 15px; background-color: white; border-radius: 5px;">
                <v-btn @click="confirmAddress" 
                    :disabled="!validAddress"
                    depressed color="primary">
                    <span v-if="!marker">Click to Select Location</span>
                    <span v-else-if="validAddress">{{ address.line1 }}, {{ address.city }}</span>
                    <span v-else>Invalid Location</span>
                </v-btn>
            </div> -->

            <v-card style="position: absolute; bottom: 24px; left:24px; min-width: 300px;">
                <v-card-text style="min-height: 86px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                <!-- <template v-if="addressLoading">
                    <v-skeleton-loader style="width: 100%;" class="address-loader"  type="list-item-two-line"></v-skeleton-loader>
                </template> -->
                <template v-if="validAddress">
                    <div style="width: 100%; display: flex; align-items: center;">
                        <span class="text-h6">{{ address.line1 }}</span>
                    </div>
                    <span style="width: 100%;">{{ address.city }}, {{ address.state }} {{ address.zip }}, {{ address.country }}</span>
                </template>
                <template v-else-if="!validAddress && marker">
                    <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
                        <span class="text-center text-overline">Invalid Location</span>
                    </div>
                    
                </template>
                <template v-else>
                    <div style="width: 100%; display: flex; align-items: center;">
                        <span class="text-center text-overline">Click on the map to select a location</span>
                    </div>
                    
                </template>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed @click="clearMarker">Clear</v-btn>
                    <v-btn color="primary" :disabled="!validAddress" depressed @click="confirmAddress">Select Address</v-btn>
                </v-card-actions>
            </v-card>
        </v-card>
    </v-dialog>


</template>
<script>
    export default {
        data() {
            return {
                dialog: false,
                marker: null,
                markerIcon: {},
                address: {
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    country: '',
                    zip: ''
                },
                mapOptions:{
                    mapTypeId: 'roadmap',
                    gestureHandling: 'greedy',
                    zoomControlOptions: {},
                    streetViewControlOptions: {},
                    circle1InfoWindowOpened: true,
                    circle2InfoWindowOpened: true,
                    styles: [{featureType: "administrative",elementTypefeatureType: "geometry",stylers: [{visibility: "on"}]},{featureType: "administrative.neighborhood",stylers: [{visibility: "on"}]},{featureType: "landscape.man_made",elementType: "labels.icon",stylers: [{weight: 5}]},{featureType: "landscape.natural",elementType: "geometry.fill",stylers: [{color: "#dddde4"}]},{featureType: "poi",stylers: [{visibility: "on"}]},{featureType: "poi",elementType: "labels.icon",stylers: [{visibility: "on"}]},{featureType: "poi",elementType: "geometry.fill",stylers: [{color: "#dad7fe"}]},{featureType: "poi",elementType: "labels.text",stylers: [{visibility: "off"}]},{featureType: "poi.park",elementType: "geometry.fill",stylers: [{visibility: "on"}]},{featureType: "road.highway",elementType: "geometry.fill",stylers: [{color: "#c2c0d3"}]},{featureType: "road.highway",elementType: "geometry.stroke",stylers: [{color: "#9897af"}]},{featureType: "road",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road",elementType: "labels.icon",stylers: [{visibility: "on"}]},{featureType: "road.arterial",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road.highway",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road.local",stylers: [{visibility: "on"}]},{featureType: "road.local",elementType: "geometry.fill",stylers: [{color: "#b8b8bf"},{weight: 3}]},{featureType: "road.local",elementType: "geometry.stroke",stylers: [{visibility: "on"}]},{featureType: "transit",stylers: [{visibility: "on"}]},{featureType: "water",elementType: "geometry.fill",stylers: [{color: "#aeb7f9"}]},{featureType: "water",elementType: "labels.text",stylers: [{visibility: "on"}]}],
                }
            }
        },
        computed:{
            validAddress(){
                return this.address.line1 && this.address.city && this.address.state && this.address.zip;
            }
        },
        methods: {
            closeDialog() {
                this.dialog = false;
                
            },
            openDialog() {
                this.dialog = true;
                markerIcon = {
                    url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-w.png',
                    scaledSize: new google.maps.Size(28.125, 36),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(14.05, 36),
                    labelOrigin: new google.maps.Point(14.0625, 44),
                };
            },

            confirmAddress() {
                this.$emit('address-confirmed', this.address);
                this.closeDialog();
            },

            addMarker(event) {
                console.log(event.latLng.lat());
                // Add a new marker at the clicked location
                this.marker = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                };
                this.getAddress();
            },
            dragMarker(event) {
                console.log(event.latLng.lat());
                // Update the marker position
                this.marker = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                };
                this.getAddress();
            },
            clearMarker() {
                this.marker = null;
                this.address = {
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    country: '',
                    zip: ''
                };
            },

            getAddress() {
                let latlng = { lat: this.marker.lat, lng: this.marker.lng };
                console.log(google);
                let geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'location': latlng }, (results, status) => {
                    if (status === 'OK') {
                        if (results[0]) {
                            console.log(results[0]);
                            const addressComponents = results[0].address_components;
                            this.address = {
                                line1: '',
                                line2: '',
                                city: '',
                                state: '',
                                country: '',
                                zip: ''
                            };
                            const getComponent = (type) =>
                            addressComponents.find((component) => component.types.includes(type));

                            // Populate address fields
                            const streetNumber = getComponent('street_number');
                            const route = getComponent('route');
                            const locality = getComponent('locality');
                            const postalTown = getComponent('postal_town');
                            const adminArea = getComponent('administrative_area_level_1'); // State
                            const postalCode = getComponent('postal_code');
                            const country = getComponent('country');

                            // Assign values if the components are found
                            this.address.line1 = streetNumber && route
                                ? `${streetNumber.long_name} ${route.long_name}`
                                : route
                                ? route.long_name
                                : '';
                            this.address.city = locality ? locality.long_name : postalTown ? postalTown.long_name : '';
                            this.address.state = adminArea ? adminArea.long_name : '';
                            this.address.zip = postalCode ? postalCode.long_name : '';
                            this.address.country = country ? country.long_name : '';
                            console.log(this.address);
                            
                        } else {
                            console.log('No results found');
                        }
                    } else {
                        console.log('Geocoder failed due to: ' + status);
                    }
                });
            },
        }
    }
</script>